import {
  SurveyCompletionCookieValues,
  setSurveyCookie,
  SURVEY_COMPLETION_COOKIE
} from '@aurora/shared-client/helpers/cookie/SurveyCookieHelper';
import React, { useState } from 'react';
import Button from '@aurora/shared-client/components/common/Button/Button';
import { ButtonVariant } from '@aurora/shared-client/components/common/Button/enums';
import useTranslation from '../../useTranslation';
import { EndUserComponent } from '@aurora/shared-types/pages/enums';
import SurveyModal from '../SurveyModal/SurveyModal';
import localStyles from './SurveyPromptFloatingBox.module.pcss';
import { useClassNameMapper } from 'react-bootstrap';
import useSurvey from '@aurora/shared-client/components/surveys/UseSurvey/useSurvey';

interface Props {
  /**
   * Callback to be used when the survey prompt is closed
   */
  onClose: () => void;
}

export const SURVEY_PROMPT_FLOATING_BOX = 'surveyPromptFloatingBox';

/**
 * Survey Prompt Floating Box, prompts the user to take a survey
 *
 * @author Adam Ayres
 */
const SurveyPromptFloatingBox: React.FC<Props> = ({ onClose }) => {
  const cx = useClassNameMapper(localStyles);
  const { loading, formatMessage } = useTranslation(EndUserComponent.SURVEY_PROMPT_FLOATING_BOX);
  const [showModal, setShowModal] = useState(false);
  const { ready, computedSurvey } = useSurvey(!showModal);

  function handleSubmit() {
    setShowModal(true);
  }

  function handleCancel() {
    setSurveyCookie(SURVEY_COMPLETION_COOKIE, {
      timestamp: Date.now(),
      state: SurveyCompletionCookieValues.declined
    });
    onClose();
  }

  if (loading) {
    return null;
  }

  if (showModal) {
    if (ready) {
      return (
        <SurveyModal
          onClose={() => {
            setShowModal(false);
            onClose();
          }}
          computedSurvey={computedSurvey}
        />
      );
    } else {
      return null;
    }
  }

  return (
    <div className={cx('lia-box')}>
      <h3 className={cx('lia-g-mb-5')}>{formatMessage('title')}</h3>
      <small className={cx('lia-g-mb-15')}>{formatMessage('description')}</small>
      <section className={cx('d-flex flex-column lia-g-column-gap-10')}>
        <Button variant={ButtonVariant.PRIMARY} onClick={handleSubmit} block>
          {formatMessage('yes')}
        </Button>
        <Button variant={ButtonVariant.LIGHT} onClick={handleCancel} block>
          {formatMessage('no')}
        </Button>
      </section>
    </div>
  );
};

export default SurveyPromptFloatingBox;
